// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3EosL","header":"Messages_header__yFm8W"};